import React, { PureComponent } from "react"
import { string } from "prop-types"
import enhanceWithClickOutside from "react-click-outside"

import Heading from "../heading/heading"
import SelectDropdownList from "./select-dropdown-list"
import FormErrorMessage from "../form-error-message/form-error-message"

import "./select-dropdown.scss"

class SelectDropdown extends PureComponent {
  constructor() {
    super()
    this.state = {
      open: false,
      editing: false,
    }
  }

  componentDidMount() {
    if (this.props.resetDefaultState) {
      this.resetDefaultState()
    }
  }

  handleClickOutside = () => {
    this.setState({
      editing: false,
    })
  }

  resetDefaultState = () => {
    this.changeOption({
      forLabel: this.props.forLabel,
      value: 0,
    })
  }

  changeOption = ({ forLabel, value }) => {
    this.props.onClick({
      forLabel: forLabel,
      value,
    })
    this.toggleOpen(false)
  }

  toggleOpen = (newState) => {
    this.setState({
      open: newState === false ? newState : !this.state.open,
    })
  }

  toggleEditing = () => {
    this.setState({
      editing: !this.state.editing,
    })
  }

  render() {
    const {
      label,
      options,
      selectedOptionId,
      forLabel,
      isValid,
      validationErrorMsg,
      headingElement,
      hideInitEdit,
      isEditable,
      customLabel,
      className = "",

      // 🆕 Added className props for each element
      wrapperClassName,
      innerClassName,
      labelWrapperClassName,
      flexWrapperClassName,
      selectedWrapperClassName,
      buttonClassName,
      listWrapperClassName,
      staticWrapperClassName,
      staticValueClassName,
      staticEditClassName,
      editButtonClassName,
      isIcons = false,
      disabled,
    } = this.props
    const { open, editing } = this.state

    const selectedOption = options.filter(
      (option) => option.itemId === selectedOptionId
    )[0]
    const selectedOptionLabel = customLabel
      ? selectedOption?.[customLabel]
      : selectedOption?.label || ""

    return (
      <div className={`select-dropdown ${className} ${wrapperClassName || ""}`}>
        <FormErrorMessage
          isValid={isValid}
          validationErrorMsg={validationErrorMsg}
        />

        {!hideInitEdit || editing ? (
          <>
            <div
              className={`select-dropdown__inner select-dropdown-inner-flex ${
                innerClassName || ""
              }`}
            >
              <div
                className={`select-dropdown__label ${
                  labelWrapperClassName || ""
                }`}
              >
                <Heading copy={label} element={headingElement} />
              </div>
              <div className={`flex-1 ${flexWrapperClassName || ""}`}>
                <div
                  className={`select-dropdown__selected ${
                    selectedWrapperClassName || ""
                  }`}
                >
                  <button
                    disabled={disabled}
                    type="button"
                    onClick={this.toggleOpen}
                    className={buttonClassName || ""}
                  >
                    {isIcons && <img src="/static/icons/most.svg" />}
                    {selectedOptionLabel}
                  </button>
                </div>
                <div
                  className={`select-dropdown__list ${
                    listWrapperClassName || ""
                  }`}
                >
                  {open && (
                    <SelectDropdownList
                      disabled={disabled}
                      options={options}
                      forLabel={forLabel}
                      changeOption={this.changeOption}
                      toggleOpen={this.toggleOpen}
                      customLabel={customLabel}
                    />
                  )}
                </div>
              </div>
            </div>
          </>
        ) : (
          <div
            className={`select-dropdown__static ${
              staticWrapperClassName || ""
            }`}
          >
            <div
              className={`select-dropdown__static__value ${
                staticValueClassName || ""
              }`}
            >
              {selectedOptionLabel}
              {isEditable && (
                <span
                  className={`select-dropdown__static__edit ${
                    staticEditClassName || ""
                  }`}
                >
                  <button
                    onClick={this.toggleEditing}
                    className={editButtonClassName || ""}
                  >
                    Edit
                  </button>
                </span>
              )}
            </div>
          </div>
        )}
      </div>
    )
  }
}

SelectDropdown.propTypes = {
  headingElement: string,
}

SelectDropdown.defaultProps = {
  headingElement: "h3",
}

export default enhanceWithClickOutside(SelectDropdown)
